import * as _ from 'lodash'

export const LTS = {
  NAME: 'lotteria',
  NAMESPACE: (name) => `lotteria/${name}`,
  GET_PRODUCT_OPTIONS: 'GET_PRODUCT_OPTIONS',
  SET_PRODUCT_OPTIONS: 'SET_PRODUCT_OPTIONS',
  GET_TARGET: 'GET_TARGET',
  SET_TARGET: 'SET_TARGET',
  CLEAR: 'CLEAR',
  GET_CART: 'GET_CART',
  SET_CART: 'SET_CART',
  ADD_CART: 'ADD_CART',
  GET_TOTAL_PRICE: 'GET_TOTAL_PRICE',
  GET_TOTAL_COUNT: 'GET_TOTAL_COUNT',
  UPDATE_ITEM: 'UPDATE_ITEM',
  REMOVE_ITEM: 'REMOVE_ITEM',
  CALCULATE: 'CALCULATE',
}

export const state = {
  target: null,
  totalPrice: 0,
  totalCount: 0,
  items: [],
  productOptions: {},
}

export const mutations = {
  [LTS.CLEAR](state) {
    state.items = []
    state.totalPrice = 0
    state.productOptions = {}
  },
  [LTS.SET_PRODUCT_OPTIONS](state, options) {
    state.productOptions = options
  },
  [LTS.SET_TARGET](state, { target }) {
    state.target = target
  },
  [LTS.SET_CART](state, { items }) {
    state.items = items || []
  },
  [LTS.ADD_CART](state, { item }) {
    state.items.push(item)
  },
  [LTS.UPDATE_ITEM](state, { id, value }) {
    const i = state.items.map((item) => item.id).indexOf(id)
    Object.assign(state.items[i], value)
  },
  [LTS.REMOVE_ITEM](state, { id }) {
    const i = state.items.map((item) => item.id).indexOf(id)
    state.items.splice(i, 1)
  },
  [LTS.CALCULATE](state) {
    state.totalPrice = _.sum(state.items.map((it) => it.price * it.quantity))
    state.totalCount = _.sumBy(state.items, 'quantity')
  },
}

export const getters = {
  [LTS.GET_PRODUCT_OPTIONS](state) {
    return state.productOptions
  },
  [LTS.GET_TOTAL_PRICE](state) {
    return state.totalPrice
  },
  [LTS.GET_TOTAL_COUNT](state) {
    return state.totalCount
  },
  [LTS.GET_CART](state) {
    return state.items
  },
  [LTS.GET_TARGET](state) {
    return state.target
  },
}

export const actions = {
  [LTS.CLEAR]({ commit, dispatch, getters }) {
    commit(LTS.CLEAR)
  },
  [LTS.SET_TARGET]({ commit, dispatch, getters }, { target }) {
    commit(LTS.SET_TARGET, { target })
  },
  [LTS.ADD_CART]({ commit, dispatch, getters, state }, { item, quantity = 1 }) {
    if (item && item.id) {
      const orgItem = state.items.find((it) => it.id === item.id)
      if (!orgItem) {
        const clonedItem = _.cloneDeep(item)
        clonedItem.quantity = quantity
        commit(LTS.ADD_CART, { item: clonedItem })
      } else {
        commit(LTS.UPDATE_ITEM, { id: item.id, value: { quantity: orgItem.quantity + quantity } })
      }

      commit(LTS.CALCULATE)
    }
  },
  [LTS.UPDATE_ITEM]({ commit, dispatch, getters }, { id, newVal }) {},
  [LTS.REMOVE_ITEM]({ commit, dispatch, getters }, { id }) {
    commit(LTS.REMOVE_ITEM, { id })
  },
}
